<i18n>
{
  "en":{
    "title": "Previous configuration already exists",
    "text": "This will override the previously issued configration file. Do you wish to continue?",
    "ok": "Yes",
    "cancel": "No"
  },
  "da": {
    "title": "Tidligere konfigurationsfil findes",
    "text": "Dette over overskrive den tidligere konfigurationsfil. Ønsker du at fortsætte?",
    "ok": "Ja",
    "cancel": "Nej"
  }
}
</i18n>

<template>
  <b-modal ref="previousConfigurtionExists" 
    id="previousConfigurtionExists"
    :title="$t('title')" 
    no-close-on-backdrop 
    @ok="ok"
    :okTitle="$t('ok')"
    :cancelTitle="$t('cancel')"
  >
  <p>
    {{$t('text')}}
  </p>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    ok(){
      this.$emit('accept', null)
    },
    show(){
      this.$refs['previousConfigurtionExists'].show();
    },
    hide(){
      
    }
  }
}
</script>


// WEBPACK FOOTER //
// WebApp/components/modals/PreviousConfigurationExistsModal.vue